import * as constants from './constants';
import controller from './controller';

const dispatchFail = (dispatch: any, failType: string, error: any, payload: object) => {
  dispatch({
    type: failType,
    payload: {
      error,
      loading: false,
      ...payload,
    },
  });
  throw error;
};

export function getUserHistory(data: { since: string | number; userNotificationDays: number }) {
  return (dispatch: any) => {
    dispatch({
      type: constants.FETCH_USER_HISTORY,
      payload: { loadingUserHistory: true, error: undefined, userNotificationDays: data.userNotificationDays },
    });

    return controller.getUserHistory(data.since).then(response => {
      if (response.errorData) {
        return dispatchFail(
          dispatch,
          constants.FETCH_USER_HISTORY_FAIL,
          response.errorData,
          { loadingUserHistory: false }
        );
      }

      return dispatch({
        type: constants.FETCH_USER_HISTORY_SUCCESS,
        payload: { userNotificationHistory: response.data, loadingUserHistory: false, error: undefined },
      });
    });
  };
}
